import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { GlobalNamespace as _GlobalNS } from '../../../../environments/environment';
import { GlobalService } from '../../../core/global.service';
import { Subscription } from 'rxjs';

import { PartnershipService } from '../../partnership.service';
import { PartnerRelationship } from '../../models/PartnerRelationship';
import { Relationship, RelationshipDataGroup, PartnershipDataGroup } from '../../models/UserRelationship';
import { Person } from '../../models/Person';
import { AssetGroupService } from '../../asset-group.service';


@Component({
  selector: 'app-add-asset-group',
  templateUrl: './add-asset-group.component.html',
  styleUrls: ['./add-asset-group.component.scss']
})
export class AddAssetGroupComponent implements OnInit, OnDestroy {

  @Input() displayDialog: boolean;
  @Output() onDialogHide = new EventEmitter<boolean>();
  @Output() onAdd = new EventEmitter<PartnershipDataGroup>();

  loading = false;
  processing = false;
  subscription: Subscription;
  partnerRelationship: PartnerRelationship[];
  relationship: Relationship[];
  relationshipSelected: Relationship;
  assignedUsers: Person[];
  addFormdata: RelationshipDataGroup;
  relationshipDataItemSelected = [];
  assetGroupVerification = false;
  assetGroupExists = false;

  public addForm: FormGroup = new FormGroup({
    RelationshipId: new FormControl('', [Validators.required]),
    RelationshipGroupId: new FormControl('0'),
    RelationshipGroupName: new FormControl('', [Validators.required]),
    Items: new FormControl('', [Validators.required]),
    Assigned: new FormControl('')
  });

  relationshipGroupNameControl = this.addForm.get('RelationshipGroupName');
  relationshipControl = this.addForm.get('RelationshipId');
  itemsControl = this.addForm.get('Items');
  assignedControl = this.addForm.get('Assigned');

  constructor(private partnershipSvc: PartnershipService, private assetGroupSvc: AssetGroupService, private _global: GlobalService) { }

  ngOnInit() {
    this.loading = true;
    this.subscription = this.partnershipSvc.findByPerson()
      .subscribe((partnerRelationshipData: any) => {
        this.partnerRelationship = <PartnerRelationship[]>partnerRelationshipData.data;
        this.relationship = [];
        for (let i = 0; i < this.partnerRelationship.length; i++) {
          this.partnerRelationship[i].ChildCompany.Name = this.partnerRelationship[i].ChildCompany.Name + ' - ' +  this.partnerRelationship[i].ParentCompany.Name;
          this.relationship.push({Id: this.partnerRelationship[i].RelationshipId, Company: this.partnerRelationship[i].ChildCompany});
        }
        this.loading = false;
      });
  }

  relationshipChange(): void {
    const currentPersonId = this._global.find((<any>_GlobalNS).paths.PersonId);
    this.assignedUsers = [];
    const partnership = this.partnerRelationship.filter((relationship: PartnerRelationship) =>
      relationship.RelationshipId === this.relationshipControl.value.Id );
      for (let i = 0, aData = partnership[0].PartnerUser; i < aData.length; i++) {
        if (aData[i].Person.PersonId.toString() !== currentPersonId.toString()) {
          aData[i].Person.FullName = aData[i].Person.LastName + ', ' + aData[i].Person.FirstName;
          this.assignedUsers.push(aData[i].Person);
        }
      }
    this.onRelationshipGroupNameChange();
  }

  onSubmit() {
    if (this.addForm) {
      this.processing = true;
      this.addFormdata = this.addForm.value;
      this.addFormdata.RelationshipId = this.addFormdata.RelationshipId['Id'];
      this.subscription = this.assetGroupSvc.create(this.addFormdata)
      .subscribe((assetData)  => {
        this.onAdd.emit(assetData['data'][0]);
        this.processing = false;
        this.dialogHide();
      });
    }
  }

  onRelationshipGroupNameChange() {
    if (this.relationshipControl.value.Id && this.relationshipGroupNameControl.value) {
      this.assetGroupExists = false;
      this.assetGroupVerification = true;
      this.subscription = this.assetGroupSvc.assetGroupNameExists(this.relationshipGroupNameControl.value, this.relationshipControl.value.Id)
        .subscribe((res: any) => {
          this.assetGroupExists = res.data[0].ExistingGroup;
          this.assetGroupVerification = false;
        });
    }
  }

  dialogHide() {
    this.onDialogHide.emit(false);
    this.displayDialog = false;
  }

  dialogShow() { }

  ngOnDestroy() {
    if (this.subscription) { this.subscription.unsubscribe(); }
  }

}
